export default {
  // 頁面標題
  title: '活動列表',
  // 頂部操作
  addActivity: '添加活動',
  sortLevelTooltip:
    '優先級說明：數字越大優先級越高。如果二維碼分佈在多個活動中，消費者掃碼將優先進入優先級更高的活動。',
  // 搜索區
  activityName: '活動名稱',
  activityNamePlaceholder: '請輸入活動名稱',
  activityId: '活動ID',
  activityIdPlaceholder: '請輸入活動ID',
  activityNo: '活動編號',
  activityNoPlaceholder: '請輸入活動編號',
  activityStatus: '活動狀態',
  activityStatusPlaceholder: '全部',
  codeSn: 'QR Code',
  codeSnPlaceholder: '請輸入QR Code',
  search: '搜索',
  reset: '重置',
  // 狀態
  statusAll: '全部',
  statusNotStarted: '未開始',
  statusActive: '進行中',
  statusEnded: '已結束',
  statusDisabled: '已禁用',
  // 表格列
  colActivityId: '活動ID',
  colActivityCode: '活動編號',
  colActivityName: '活動名稱',
  colActivityTime: '活動時間',
  colStatus: '狀態',
  colSortLevel: '優先級',
  colRemark: '活動備註',
  colCreateTime: '創建時間',
  colAction: '操作',
  // 操作
  actions: '操作',
  detail: '詳情',
  edit: '編輯',
  disable: '禁用',
  enable: '啟用',
  delete: '刪除',
  // 時間範圍
  timeRangeSep: '至',
  // 排序編輯
  sortLevelPlaceholder: '請輸入排序值',
  // 確認彈窗
  confirmDeleteTitle: '確認刪除',
  confirmDeleteContent: '確定要刪除該活動嗎？刪除後不可恢復。',
  confirmToggleTitle: '確認操作',
  confirmDisableContent: '確定要禁用該活動嗎？',
  confirmEnableContent: '確定要啟用該活動嗎？',
  // 空狀態
  emptyText: '暫無活動數據',
};
